import React from "react";

const navigationConfig = [
  /*
  {
    subMenu: false,
    name: "Users",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
      >
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
          <polygon points="0 0 24 0 24 24 0 24" />
          <path
            d="M18,14 C16.3431458,14 15,12.6568542 15,11 C15,9.34314575 16.3431458,8 18,8 C19.6568542,8 21,9.34314575 21,11 C21,12.6568542 19.6568542,14 18,14 Z M9,11 C6.790861,11 5,9.209139 5,7 C5,4.790861 6.790861,3 9,3 C11.209139,3 13,4.790861 13,7 C13,9.209139 11.209139,11 9,11 Z"
            fill="#000000"
            fillRule="nonzero"
            opacity="0.3"
          />
          <path
            d="M17.6011961,15.0006174 C21.0077043,15.0378534 23.7891749,16.7601418 23.9984937,20.4 C24.0069246,20.5466056 23.9984937,21 23.4559499,21 L19.6,21 C19.6,18.7490654 18.8562935,16.6718327 17.6011961,15.0006174 Z M0.00065168429,20.1992055 C0.388258525,15.4265159 4.26191235,13 8.98334134,13 C13.7712164,13 17.7048837,15.2931929 17.9979143,20.2 C18.0095879,20.3954741 17.9979143,21 17.2466999,21 C13.541124,21 8.03472472,21 0.727502227,21 C0.476712155,21 -0.0204617505,20.45918 0.00065168429,20.1992055 Z"
            fill="#000000"
            fillRule="nonzero"
          />
        </g>
      </svg>
    ),
    route: "/users",
  },
  */

  {
    subMenu: false,
    name: "Notifications",
    icon: (
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 512 512"
        xmlSpace="preserve"
      >
        <g stroke="none" strokeWidth={2} fill="none" fillRule="evenodd">
          <rect x={0} y={0} width={20} height={20} />
          <path
            fill="#000000"
            d="m432 352c-17.645 0-32-14.355-32-32v-112c0-38.558-15.043-74.783-42.357-102.002-16.839-16.78-37.087-28.878-59.176-35.662 3.526-6.676 5.533-14.274 5.533-22.336 0-26.467-21.533-48-48-48s-48 21.533-48 48c0 8.108 2.028 15.749 5.593 22.453-58.745 18.349-101.593 73.757-101.593 138.937v110.61c0 17.645-14.355 32-32 32-8.836 0-16 7.164-16 16v64c0 8.836 7.164 16 16 16h120.575c-.374 2.629-.575 5.299-.575 8 0 30.878 25.122 56 56 56s56-25.122 56-56c0-2.701-.2-5.371-.575-8h120.575c8.836 0 16-7.164 16-16v-64c0-8.836-7.164-16-16-16zm-176-320c8.822 0 16 7.178 16 16s-7.178 16-16 16-16-7.178-16-16 7.178-16 16-16zm24 424c0 13.234-10.766 24-24 24s-24-10.766-24-24c0-2.765.462-5.458 1.361-8h45.277c.9 2.542 1.362 5.235 1.362 8zm136-40h-128-64-128v-34.025c27.573-7.122 48-32.208 48-61.975v-110.61c0-62.307 50.062-113.173 111.597-113.389.136 0 .27-.001.405-.001 29.844 0 57.905 11.591 79.053 32.665 21.245 21.17 32.945 49.346 32.945 79.335v112c0 29.767 20.427 54.853 48 61.975z"
          />
          <path
            fill="#000000"
            d="m192 224c-8.836 0-16-7.164-16-16 0-44.112 35.888-80 80-80 8.836 0 16 7.164 16 16s-7.164 16-16 16c-26.467 0-48 21.533-48 48 0 8.836-7.164 16-16 16z"
          />
        </g>
      </svg>
    ),
    route: "/notification",
  },
  {
    subMenu: false,
    name: "Classes",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
      >
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
          <polygon points="0 0 24 0 24 24 0 24" />
          <path
            d="M18,14 C16.3431458,14 15,12.6568542 15,11 C15,9.34314575 16.3431458,8 18,8 C19.6568542,8 21,9.34314575 21,11 C21,12.6568542 19.6568542,14 18,14 Z M9,11 C6.790861,11 5,9.209139 5,7 C5,4.790861 6.790861,3 9,3 C11.209139,3 13,4.790861 13,7 C13,9.209139 11.209139,11 9,11 Z"
            fill="#000000"
            fillRule="nonzero"
            opacity="0.3"
          />
          <path
            d="M17.6011961,15.0006174 C21.0077043,15.0378534 23.7891749,16.7601418 23.9984937,20.4 C24.0069246,20.5466056 23.9984937,21 23.4559499,21 L19.6,21 C19.6,18.7490654 18.8562935,16.6718327 17.6011961,15.0006174 Z M0.00065168429,20.1992055 C0.388258525,15.4265159 4.26191235,13 8.98334134,13 C13.7712164,13 17.7048837,15.2931929 17.9979143,20.2 C18.0095879,20.3954741 17.9979143,21 17.2466999,21 C13.541124,21 8.03472472,21 0.727502227,21 C0.476712155,21 -0.0204617505,20.45918 0.00065168429,20.1992055 Z"
            fill="#000000"
            fillRule="nonzero"
          />
        </g>
      </svg>
    ),
    route: "/classes",
  },
  {
    subMenu: false,
    name: "Salles",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
      >
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
          <rect x={0} y={0} width={24} height={24} />
          <path
            d="M6.54246133,21.5014597 L8.1406184,15.5370564 C8.28356021,15.0035903 8.83189716,14.6870078 9.36536327,14.8299496 C9.89882937,14.9728914 10.2154119,15.5212284 10.07247,16.0546945 L8.47431299,22.0190978 C8.33137118,22.5525639 7.78303422,22.8691464 7.24956812,22.7262046 C6.71610201,22.5832628 6.39951952,22.0349258 6.54246133,21.5014597 Z M17.4495897,21.4711096 C17.5925315,22.0045757 17.275949,22.5529126 16.7424829,22.6958545 C16.2090168,22.8387963 15.6606799,22.5222138 15.517738,21.9887477 L14.2148496,17.126302 C14.0719078,16.5928359 14.3884903,16.0444989 14.9219564,15.9015571 C15.4554225,15.7586153 16.0037595,16.0751978 16.1467013,16.6086639 L17.4495897,21.4711096 Z"
            fill="#000000"
            opacity="0.3"
          />
          <path
            d="M7.36092084,1 L16.6390792,1 C17.7436487,1 18.6390792,1.8954305 18.6390792,3 C18.6390792,3.11016172 18.6299775,3.22013512 18.611867,3.32879797 L17.0696334,12.5821995 C17.0294511,12.8232935 16.820856,13 16.5764365,13 L7.42356354,13 C7.17914397,13 6.97054891,12.8232935 6.93036658,12.5821995 L5.388133,3.32879797 C5.20654289,2.23925733 5.94258223,1.20880226 7.03212287,1.02721215 C7.14078572,1.00910168 7.25075912,1 7.36092084,1 Z M5.5,14 L18.5,14 C19.3284271,14 20,14.6715729 20,15.5 C20,16.3284271 19.3284271,17 18.5,17 L5.5,17 C4.67157288,17 4,16.3284271 4,15.5 C4,14.6715729 4.67157288,14 5.5,14 Z"
            fill="#000000"
          />
        </g>
      </svg>
    ),
    route: "/Salles",
  },
  {
    subMenu: false,
    name: "Matières",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
      >
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
          <rect x={0} y={0} width={24} height={24} />
          <path
            d="M8,3 L8,3.5 C8,4.32842712 8.67157288,5 9.5,5 L14.5,5 C15.3284271,5 16,4.32842712 16,3.5 L16,3 L18,3 C19.1045695,3 20,3.8954305 20,5 L20,21 C20,22.1045695 19.1045695,23 18,23 L6,23 C4.8954305,23 4,22.1045695 4,21 L4,5 C4,3.8954305 4.8954305,3 6,3 L8,3 Z"
            fill="#000000"
            opacity="0.3"
          />
          <path
            d="M11,2 C11,1.44771525 11.4477153,1 12,1 C12.5522847,1 13,1.44771525 13,2 L14.5,2 C14.7761424,2 15,2.22385763 15,2.5 L15,3.5 C15,3.77614237 14.7761424,4 14.5,4 L9.5,4 C9.22385763,4 9,3.77614237 9,3.5 L9,2.5 C9,2.22385763 9.22385763,2 9.5,2 L11,2 Z"
            fill="#000000"
          />
          <rect
            fill="#000000"
            opacity="0.3"
            x={10}
            y={9}
            width={7}
            height={2}
            rx={1}
          />
          <rect
            fill="#000000"
            opacity="0.3"
            x={7}
            y={9}
            width={2}
            height={2}
            rx={1}
          />
          <rect
            fill="#000000"
            opacity="0.3"
            x={7}
            y={13}
            width={2}
            height={2}
            rx={1}
          />
          <rect
            fill="#000000"
            opacity="0.3"
            x={10}
            y={13}
            width={7}
            height={2}
            rx={1}
          />
          <rect
            fill="#000000"
            opacity="0.3"
            x={7}
            y={17}
            width={2}
            height={2}
            rx={1}
          />
          <rect
            fill="#000000"
            opacity="0.3"
            x={10}
            y={17}
            width={7}
            height={2}
            rx={1}
          />
        </g>
      </svg>
    ),
    route: "/subjects",
  },
  {
    subMenu: false,
    name: "Eléves",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
      >
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
          <rect x={0} y={0} width={24} height={24} />
          <path
            d="M6.182345,4.09500888 C6.73256296,3.42637697 7.56648864,3 8.5,3 L15.5,3 C16.4330994,3 17.266701,3.42600075 17.8169264,4.09412386 C17.8385143,4.10460774 17.8598828,4.11593789 17.8809917,4.1281251 L22.5900048,6.8468751 C23.0682974,7.12301748 23.2321726,7.73460788 22.9560302,8.21290051 L21.2997802,11.0816097 C21.0236378,11.5599023 20.4120474,11.7237774 19.9337548,11.4476351 L18.5,10.6198563 L18.5,19 C18.5,19.5522847 18.0522847,20 17.5,20 L6.5,20 C5.94771525,20 5.5,19.5522847 5.5,19 L5.5,10.6204852 L4.0673344,11.4476351 C3.58904177,11.7237774 2.97745137,11.5599023 2.70130899,11.0816097 L1.04505899,8.21290051 C0.768916618,7.73460788 0.932791773,7.12301748 1.4110844,6.8468751 L6.12009753,4.1281251 C6.14061376,4.11628005 6.16137525,4.10524462 6.182345,4.09500888 Z"
            fill="#000000"
            opacity="0.3"
          />
          <path
            d="M9.85156673,3.2226499 L9.26236944,4.10644584 C9.11517039,4.32724441 9.1661011,4.62457583 9.37839459,4.78379594 L11,6 L10.0353553,12.7525126 C10.0130986,12.9083095 10.0654932,13.0654932 10.1767767,13.1767767 L11.6464466,14.6464466 C11.8417088,14.8417088 12.1582912,14.8417088 12.3535534,14.6464466 L13.8232233,13.1767767 C13.9345068,13.0654932 13.9869014,12.9083095 13.9646447,12.7525126 L13,6 L14.6216054,4.78379594 C14.8338989,4.62457583 14.8848296,4.32724441 14.7376306,4.10644584 L14.1484333,3.2226499 C14.0557004,3.08355057 13.8995847,3 13.7324081,3 L10.2675919,3 C10.1004153,3 9.94429962,3.08355057 9.85156673,3.2226499 Z"
            fill="#000000"
          />
        </g>
      </svg>
    ),
    route: "/students",
  },
  {
    subMenu: false,
    name: "Parents",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
      >
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
          <polygon points="0 0 24 0 24 24 0 24" />
          <path
            d="M18,14 C16.3431458,14 15,12.6568542 15,11 C15,9.34314575 16.3431458,8 18,8 C19.6568542,8 21,9.34314575 21,11 C21,12.6568542 19.6568542,14 18,14 Z M9,11 C6.790861,11 5,9.209139 5,7 C5,4.790861 6.790861,3 9,3 C11.209139,3 13,4.790861 13,7 C13,9.209139 11.209139,11 9,11 Z"
            fill="#000000"
            fillRule="nonzero"
            opacity="0.3"
          />
          <path
            d="M17.6011961,15.0006174 C21.0077043,15.0378534 23.7891749,16.7601418 23.9984937,20.4 C24.0069246,20.5466056 23.9984937,21 23.4559499,21 L19.6,21 C19.6,18.7490654 18.8562935,16.6718327 17.6011961,15.0006174 Z M0.00065168429,20.1992055 C0.388258525,15.4265159 4.26191235,13 8.98334134,13 C13.7712164,13 17.7048837,15.2931929 17.9979143,20.2 C18.0095879,20.3954741 17.9979143,21 17.2466999,21 C13.541124,21 8.03472472,21 0.727502227,21 C0.476712155,21 -0.0204617505,20.45918 0.00065168429,20.1992055 Z"
            fill="#000000"
            fillRule="nonzero"
          />
        </g>
      </svg>
    ),
    route: "/parents",
  },
  {
    subMenu: false,
    name: "Enseignants",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
      >
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
          <polygon points="0 0 24 0 24 24 0 24" />
          <path
            d="M18,14 C16.3431458,14 15,12.6568542 15,11 C15,9.34314575 16.3431458,8 18,8 C19.6568542,8 21,9.34314575 21,11 C21,12.6568542 19.6568542,14 18,14 Z M9,11 C6.790861,11 5,9.209139 5,7 C5,4.790861 6.790861,3 9,3 C11.209139,3 13,4.790861 13,7 C13,9.209139 11.209139,11 9,11 Z"
            fill="#000000"
            fillRule="nonzero"
            opacity="0.3"
          />
          <path
            d="M17.6011961,15.0006174 C21.0077043,15.0378534 23.7891749,16.7601418 23.9984937,20.4 C24.0069246,20.5466056 23.9984937,21 23.4559499,21 L19.6,21 C19.6,18.7490654 18.8562935,16.6718327 17.6011961,15.0006174 Z M0.00065168429,20.1992055 C0.388258525,15.4265159 4.26191235,13 8.98334134,13 C13.7712164,13 17.7048837,15.2931929 17.9979143,20.2 C18.0095879,20.3954741 17.9979143,21 17.2466999,21 C13.541124,21 8.03472472,21 0.727502227,21 C0.476712155,21 -0.0204617505,20.45918 0.00065168429,20.1992055 Z"
            fill="#000000"
            fillRule="nonzero"
          />
        </g>
      </svg>
    ),
    route: "/teachers",
  },

  {
    subMenu: true,
    name: "Emploi",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 24 24"
        version="1.1"
      >
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
          <rect x={0} y={0} width={24} height={24} />
          <path
            d="M10.9630156,7.5 L11.0475062,7.5 C11.3043819,7.5 11.5194647,7.69464724 11.5450248,7.95024814 L12,12.5 L15.2480695,14.3560397 C15.403857,14.4450611 15.5,14.6107328 15.5,14.7901613 L15.5,15 C15.5,15.2109164 15.3290185,15.3818979 15.1181021,15.3818979 C15.0841582,15.3818979 15.0503659,15.3773725 15.0176181,15.3684413 L10.3986612,14.1087258 C10.1672824,14.0456225 10.0132986,13.8271186 10.0316926,13.5879956 L10.4644883,7.96165175 C10.4845267,7.70115317 10.7017474,7.5 10.9630156,7.5 Z"
            fill="#000000"
          />
          <path
            d="M7.38979581,2.8349582 C8.65216735,2.29743306 10.0413491,2 11.5,2 C17.2989899,2 22,6.70101013 22,12.5 C22,18.2989899 17.2989899,23 11.5,23 C5.70101013,23 1,18.2989899 1,12.5 C1,11.5151324 1.13559454,10.5619345 1.38913364,9.65805651 L3.31481075,10.1982117 C3.10672013,10.940064 3,11.7119264 3,12.5 C3,17.1944204 6.80557963,21 11.5,21 C16.1944204,21 20,17.1944204 20,12.5 C20,7.80557963 16.1944204,4 11.5,4 C10.54876,4 9.62236069,4.15592757 8.74872191,4.45446326 L9.93948308,5.87355717 C10.0088058,5.95617272 10.0495583,6.05898805 10.05566,6.16666224 C10.0712834,6.4423623 9.86044965,6.67852665 9.5847496,6.69415008 L4.71777931,6.96995273 C4.66931162,6.97269931 4.62070229,6.96837279 4.57348157,6.95710938 C4.30487471,6.89303938 4.13906482,6.62335149 4.20313482,6.35474463 L5.33163823,1.62361064 C5.35654118,1.51920756 5.41437908,1.4255891 5.49660017,1.35659741 C5.7081375,1.17909652 6.0235153,1.2066885 6.2010162,1.41822583 L7.38979581,2.8349582 Z"
            fill="#000000"
            opacity="0.3"
          />
        </g>
      </svg>
    ),
    subMenuList: [
      {
        name: "Emploi Classe",
        route: "/emploi/student",
      },
      {
        name: "Emploi Enseignant",
        route: "/emploi/teacher",
      },
    ],
  },

  {
    subMenu: false,
    name: "Examens",
    icon: (
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 512 512"
        xmlSpace="preserve"
      >
        <g stroke="none" strokeWidth={2} fill="none" fillRule="evenodd">
          <rect x={0} y={0} width={20} height={20} />
          <path
            fill="#000000"
            d="M416.322,120.239c-4.142,0-7.5,3.358-7.5,7.5V464.42c0,0.285-0.231,0.516-0.516,0.516H143.774c-4.142,0-7.5,3.358-7.5,7.5
			c0,4.142,3.358,7.5,7.5,7.5h264.532c8.556,0,15.516-6.96,15.516-15.516V127.739C423.822,123.597,420.464,120.239,416.322,120.239z
			"
          />
          <path
            fill="#000000"
            d="M440.37,32.064h-69.039L346.16,6.893C341.715,2.448,335.806,0,329.52,0H71.628c-8.556,0-15.516,6.96-15.516,15.516
			v448.903c0,8.556,6.96,15.516,15.516,15.516h16.548v16.548c0,8.556,6.96,15.516,15.516,15.516H440.37
			c8.556,0,15.516-6.96,15.516-15.516V47.581C455.886,39.025,448.926,32.064,440.37,32.064z M335.644,17.59l70.587,70.587H336.16
			c-0.285,0-0.516-0.231-0.516-0.516V17.59z M440.886,496.484c0,0.285-0.231,0.516-0.516,0.516H103.692
			c-0.285,0-0.516-0.231-0.516-0.516v-16.548h8.53c4.142,0,7.5-3.358,7.5-7.5c0-4.142-3.358-7.5-7.5-7.5H71.628
			c-0.285,0-0.516-0.231-0.516-0.516V15.516c0-0.285,0.231-0.516,0.516-0.516h249.016v72.661c0,8.556,6.96,15.516,15.516,15.516
			h80.162c4.142,0,7.5-3.358,7.5-7.5v-1.375c0-6.285-2.448-12.195-6.893-16.64l-30.598-30.598h54.039
			c0.285,0,0.516,0.231,0.516,0.516V496.484z"
          />
          <path
            fill="#000000"
            d="M205.189,85.679c-2.929-2.929-7.678-2.929-10.606,0l-42.429,42.429c-0.202,0.201-0.529,0.201-0.73,0l-16.914-16.914h13.02
			c4.142,0,7.5-3.358,7.5-7.5c0-4.142-3.358-7.5-7.5-7.5h-19.79c-2.398,0-4.662,0.563-6.692,1.539l-4.037-4.037
			c-2.929-2.929-7.678-2.929-10.606,0c-2.929,2.929-2.929,7.678,0,10.606l5.896,5.896c-0.048,0.497-0.076,1.001-0.076,1.511v48.097
			c0,8.556,6.96,15.516,15.516,15.516h48.097c8.556,0,15.516-6.96,15.516-15.516V110.12l13.835-13.835
			C208.118,93.356,208.118,88.607,205.189,85.679z M176.354,159.807c0,0.285-0.231,0.516-0.516,0.516h-48.097
			c-0.285,0-0.516-0.231-0.516-0.516V125.12l13.593,13.593c3.025,3.025,6.998,4.538,10.972,4.538c3.973,0,7.946-1.513,10.971-4.538
			l13.593-13.593V159.807z"
          />
          <path
            fill="#000000"
            d="M175.838,304.613h-48.097c-8.556,0-15.516,6.96-15.516,15.516v48.097c0,8.556,6.96,15.516,15.516,15.516h48.097
			c8.556,0,15.516-6.961,15.516-15.516v-48.097C191.354,311.573,184.394,304.613,175.838,304.613z M176.354,368.226
			c0,0.285-0.231,0.516-0.516,0.516h-48.097c-0.285,0-0.516-0.232-0.516-0.516v-48.097c0-0.285,0.231-0.516,0.516-0.516h48.097
			c0.285,0,0.516,0.231,0.516,0.516V368.226z"
          />
          <path
            fill="#000000"
            d="M296.08,112.226h-72.145c-4.142,0-7.5,3.358-7.5,7.5c0,4.142,3.357,7.5,7.5,7.5h72.145c4.142,0,7.5-3.358,7.5-7.5
			C303.58,115.584,300.222,112.226,296.08,112.226z"
          />
          <path
            fill="#000000"
            d="M360.209,144.291H223.935c-4.142,0-7.5,3.358-7.5,7.5c0,4.142,3.357,7.5,7.5,7.5h136.274c4.142,0,7.5-3.358,7.5-7.5
			C367.709,147.649,364.352,144.291,360.209,144.291z"
          />
          <path
            fill="#000000"
            d="M296.08,216.436h-72.145c-4.142,0-7.5,3.358-7.5,7.5c0,4.142,3.357,7.5,7.5,7.5h72.145c4.142,0,7.5-3.358,7.5-7.5
			C303.58,219.794,300.222,216.436,296.08,216.436z"
          />
          <path
            fill="#000000"
            d="M360.209,248.5H223.935c-4.142,0-7.5,3.358-7.5,7.5c0,4.142,3.357,7.5,7.5,7.5h136.274c4.142,0,7.5-3.358,7.5-7.5
			C367.709,251.858,364.352,248.5,360.209,248.5z"
          />
          <path
            fill="#000000"
            d="M296.08,320.645h-72.145c-4.142,0-7.5,3.358-7.5,7.5c0,4.142,3.357,7.5,7.5,7.5h72.145c4.142,0,7.5-3.358,7.5-7.5
			C303.58,324.003,300.222,320.645,296.08,320.645z"
          />
          <path
            fill="#000000"
            d="M360.209,352.709H223.935c-4.142,0-7.5,3.358-7.5,7.5c0,4.142,3.357,7.5,7.5,7.5h136.274c4.142,0,7.5-3.358,7.5-7.5
			C367.709,356.067,364.352,352.709,360.209,352.709z"
          />
        </g>
      </svg>
    ),
    route: "/examens",
  },

  {
    subMenu: false,
    name: "Modules",
    route: "/modules",
    icon: (
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 512 512"
        xmlSpace="preserve"
      >
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
          <rect x={0} y={0} width={24} height={24} />

          <path
            fill="#000000"
            d="m245.941406 113.957031c2.453125 2.457031 5.675782 3.683594 8.894532 3.683594s6.4375-1.226563 8.890624-3.683594l39.78125-39.773437c4.90625-4.914063 4.90625-12.878906 0-17.789063-4.910156-4.914062-12.875-4.914062-17.785156 0l-39.78125 39.777344c-4.910156 4.914063-4.910156 12.878906 0 17.785156zm0 0"
          />
          <path
            fill="#000000"
            d="m312.125 113.957031c2.457031 2.457031 5.671875 3.683594 8.886719 3.683594 3.222656 0 6.4375-1.226563 8.894531-3.683594l39.78125-39.773437c4.914062-4.914063 4.914062-12.878906 0-17.789063-4.910156-4.914062-12.875-4.914062-17.789062 0l-39.777344 39.777344c-4.910156 4.914063-4.910156 12.878906.003906 17.785156zm0 0"
          />
          <path
            fill="#000000"
            d="m599.824219 486.949219h-44.496094v-41.75c0-6.941407-5.636719-12.578125-12.578125-12.578125h-47.269531v-28.601563h44.5c10.398437 0 18.863281-8.457031 18.863281-18.863281v-114.152344c0-10.398437-8.464844-18.863281-18.863281-18.863281h-44.5v-40.742187c0-6.949219-5.632813-12.578126-12.578125-12.578126h-161.773438v-28.546874h91.371094c10.8125 0 19.613281-8.800782 19.613281-19.621094v-130.953125c0-10.816407-8.800781-19.6171878-19.613281-19.6171878h-55.605469c-6.949219 0-12.578125 5.6289068-12.578125 12.5781248 0 6.945313 5.628906 12.578125 12.578125 12.578125h50.070313v119.878907h-196.8125v-119.878907h45.835937c6.945313 0 12.578125-5.632812 12.578125-12.578125 0-6.949218-5.632812-12.5781248-12.578125-12.5781248h-51.378906c-10.8125 0-19.613281 8.8007808-19.613281 19.6171878v130.953125c0 10.820312 8.800781 19.621094 19.613281 19.621094h91.371094v28.546874h-168.4375c-6.945313 0-12.578125 5.628907-12.578125 12.578126v40.742187h-44.496094c-10.40625 0-18.867188 8.464844-18.867188 18.863281v114.152344c0 10.40625 8.460938 18.863281 18.867188 18.863281h44.496094v28.601563h-38.839844c-6.949219 0-12.578125 5.636718-12.578125 12.578125v41.75h-45.179687c-10.40625 0-18.863282 8.464843-18.863282 18.863281v114.152344c0 10.40625 8.457032 18.871094 18.863282 18.871094h114.152343c10.398438 0 18.863281-8.464844 18.863281-18.871094v-114.152344c0-10.398438-8.464843-18.863281-18.863281-18.863281h-43.820312v-29.175781h207.28125v29.175781h-43.75c-10.816407 0-19.613281 8.800781-19.613281 19.621093v112.644532c0 10.820312 8.796874 19.621094 19.613281 19.621094h6.371093c6.945313 0 12.578126-5.632813 12.578126-12.578126 0-6.945312-5.632813-12.578124-12.578126-12.578124h-.832031v-101.574219h101.574219v101.574219h-.878906c-6.945313 0-12.578125 5.632812-12.578125 12.578124 0 6.945313 5.632812 12.578126 12.578125 12.578126h6.414062c10.816406 0 19.613282-8.800782 19.613282-19.621094v-112.644532c0-10.820312-8.796876-19.621093-19.613282-19.621093h-43.75v-29.175781h209.042969v29.175781h-44.5c-10.402344 0-18.863281 8.464843-18.863281 18.863281v114.152344c0 10.40625 8.460937 18.871094 18.863281 18.871094h114.152344c10.398437 0 18.863281-8.464844 18.863281-18.871094v-114.152344c0-10.398438-8.464844-18.863281-18.863281-18.863281zm-473.597657 25.15625v101.574219h-101.574218v-101.574219zm-49.472656-133.234375v-101.574219h101.574219v101.574219zm393.574219 53.75h-330.207031v-28.601563h44.5c10.398437 0 18.863281-8.457031 18.863281-18.863281v-114.152344c0-10.398437-8.464844-18.863281-18.863281-18.863281h-44.5v-28.167969h330.207031v28.167969h-44.5c-10.40625 0-18.863281 8.464844-18.863281 18.863281v114.152344c0 10.40625 8.457031 18.863281 18.863281 18.863281h44.5zm-38.214844-53.75v-101.574219h101.574219v101.574219zm161.417969 234.808594h-101.574219v-101.574219h101.574219zm0 0"
          />
          <path
            fill="#000000"
            d="m299.167969 22.675781.367187.277344c2.277344 1.730469 4.949219 2.570313 7.605469 2.570313 3.792969 0 7.546875-1.714844 10.019531-4.972657 4.203125-5.53125 3.128906-13.414062-2.402344-17.621093l-.371093-.28125c-5.53125-4.203126-13.421875-3.128907-17.621094 2.40625-4.207031 5.527343-3.128906 13.414062 2.402344 17.621093zm0 0"
          />
          <path
            fill="#000000"
            d="m316.34375 615.945312-.363281-.277343c-5.53125-4.199219-13.421875-3.125-17.628907 2.40625-4.199218 5.53125-3.117187 13.421875 2.414063 17.625l.363281.28125c2.277344 1.726562 4.949219 2.5625 7.597656 2.5625 3.800782 0 7.554688-1.714844 10.03125-4.96875 4.199219-5.539063 3.121094-13.425781-2.414062-17.628907zm0 0"
          />
        </g>
      </svg>
    ),
  },

  {
    subMenu: false,
    name: "Cantine",
    icon: (
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 512 512"
        xmlSpace="preserve"
      >
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
          <rect x={0} y={0} width={24} height={24} />

          <path
            d="M498.682,435.326L297.917,234.56L63.357,0H45.026l-3.743,9.511c-9.879,25.104-14.1,50.78-12.205,74.249
			c2.16,26.752,12.323,49.913,29.392,66.982L241.58,333.852l24.152-24.152l169.285,189.293c16.84,16.84,45.825,17.84,63.665,0
      C516.236,481.439,516.236,452.879,498.682,435.326z"
            fill="#000000"
            opacity="0.5"
          />

          <path
            d="M156.728,291.442L13.317,434.853c-17.552,17.552-17.552,46.113,0,63.665c16.674,16.674,45.519,18.146,63.665,0
      l143.412-143.412L156.728,291.442z"
            fill="#000000"
            opacity="0.5"
          />

          <path
            d="M490.253,85.249l-81.351,81.35l-21.223-21.222l81.351-81.351l-21.222-21.222l-81.35,81.35l-21.222-21.222l81.351-81.35
			L405.366,0.361L299.256,106.471c-12.981,12.981-20.732,30.217-21.828,48.535c-0.277,4.641-1.329,9.206-3.074,13.548l68.929,68.929
      c4.342-1.747,8.908-2.798,13.548-3.075c18.318-1.093,35.554-8.846,48.535-21.827l106.11-106.109L490.253,85.249z"
            fill="#000000"
            opacity="0.5"
          />
        </g>
      </svg>
    ),
    route: "/cantine",
  },

  {
    subMenu: true,
    name: "Payment",
    icon: (
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 512 512"
        xmlSpace="preserve"
      >
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
          <rect x={0} y={0} width={24} height={300} />
          <path
            opacity="0.3"
            fill="#000000"
            d="m271 328.946c17.245-4.235 30-15.335
          30-28.092s-12.755-23.857-30-28.092z"
          />
          <path
            fill="#000000"
            d="m256 91c-90.981 0-165 74.019-165 165s74.019 165 165 165 165-74.019 165-165-74.019-165-165-165zm75 209.854c0 28.98-25.809 53.212-60 58.786v16.36c0 8.291-6.709 15-15 15s-15-6.709-15-15v-16.36c-34.191-5.574-60-29.806-60-58.786 0-8.291 6.709-15 15-15s15 6.709 15 15c0 12.757 12.755 23.857 30 28.092v-59.306c-34.191-5.574-60-29.806-60-58.786s25.809-53.212 60-58.786v-16.214c0-8.291 6.709-15 15-15s15 6.709 15 15v16.214c34.191 5.574 60 29.806 60 58.786 0 8.291-6.709 15-15 15s-15-6.709-15-15c0-12.757-12.755-23.857-30-28.092v59.306c34.191 5.573 60 29.805 60 58.786z"
          />
          <path
            opacity="0.3"
            fill="#000000"
            d="m241 182.761c-17.245 4.235-30 15.335-30 28.092s12.755 23.857 30 28.092z"
          />
          <path
            opacity="0.3"
            fill="#000000"
            d="m256 0c-140.61 0-256 115.39-256 256s115.39 256 256 256 256-115.39 256-256-115.39-256-256-256zm0 451c-107.52 0-195-87.48-195-195s87.48-195 195-195 195 87.48 195 195-87.48 195-195 195z"
          />
        </g>
      </svg>
    ),
    subMenuList: [
      {
        name: "Services",
        route: "/services",
      },
      {
        name: "Clubs",
        route: "/club",
      },
      {
        name: "Frais",
        route: "/fees",
      },
      {
        name: "Frais_Etudiant",
        route: "/payment",
      },
    ],
  },
  {
    subMenu: false,
    name: "Registre d'appel",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="48"
        height="48"
        version="1.1"
        viewBox="0 0 48 48"
        xmlSpace="preserve"
        enableBackground="new 0 0 512 512"
      >
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
          <rect x={0} y={0} width={24} height={300} />
          <path
            //fillRule="evenodd"
            fill="#000000"
            d="M41 46a1 1 0 01-1 1H12a5 5 0 01-5-5V6a5 5 0 015-5h26a1.002 1.002 0 011 1v7h1a1 1 0 011 1v36zM9 42a3 3 0 003 3h3V11h-3a4.962 4.962 0 01-3-1.022V42zM37 9V3H12a3 3 0 000 6h25zm2 2H17v34h22V11zM12 7a1 1 0 110-2h22a1 1 0 110 2H12z"
            //clipRule="evenodd"
          ></path>
        </g>
      </svg>
    ),
    route: "/absences",
  },

  {
    subMenu: true,
    name: "Actualités",
    icon: (
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 512 512"
        xmlSpace="preserve"
      >
        <g stroke="none" strokeWidth={2} fill="none" fillRule="evenodd">
          <rect x={0} y={0} width={20} height={20} />
          <path
            fill="#000000"
            d="M501.961 0H10.039C4.496 0 0 4.495 0 10.039v491.922C0 507.505 4.496 512 10.039 512h491.922c5.544 0 10.039-4.495 10.039-10.039V10.039C512 4.495 507.504 0 501.961 0zm-256 491.922H20.078V20.078H245.96v471.844zm245.961 0H266.039V20.078h225.882v471.844z"
          ></path>
          <path
            fill="#000000"
            d="M461.804 352.884c-5.544 0-10.039 4.495-10.039 10.039v88.507c0 5.545 4.496 10.039 10.039 10.039s10.039-4.495 10.039-10.039v-88.507c0-5.544-4.495-10.039-10.039-10.039zM461.567 319.759c-12.919 0-12.941 20.078 0 20.078 12.92.001 12.941-20.078 0-20.078z"
          ></path>
        </g>
      </svg>
    ),
    subMenuList: [
      {
        name: "Types d'Actualités",
        route: "/actionType",
      },
      {
        name: "Liste des Actualités",
        route: "/event",
      },
    ],
  },
  {
    subMenu: true,
    name: "Carnet de note",
    route: "/carnets",
    icon: (
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 150 150"
        xmlSpace="preserve"
      >
        <g id="_14-trophy" data-name="14-trophy">
          <g
            stroke="none"
            strokeWidth={1}
            fill="none"
            fillRule="evenodd"
            id="glyph"
          >
            <rect x={0} y={0} width={24} height={24} />
            <path d="M51.977,63.768C60.283,80.763,79.42,94.745,88,100.4v15.147L53.914,136h84.432L104,115.392V100.4c8.58-5.657,27.717-19.639,36.023-36.634C168.343,60.788,176,26.518,176,8a8,8,0,0,0-8-8H24a8,8,0,0,0-8,8C16,26.518,23.657,60.788,51.977,63.768ZM144,46.192V16h15.382C158.169,25.581,154.58,40.969,144,46.192ZM48,16V46.192C37.419,40.969,33.83,25.577,32.618,16Z" />
            <path d="M188,136a12.013,12.013,0,0,1-12-12,4,4,0,0,0-8,0,12.013,12.013,0,0,1-12,12,4,4,0,0,0,0,8,12.013,12.013,0,0,1,12,12,4,4,0,0,0,8,0,12.013,12.013,0,0,1,12-12,4,4,0,0,0,0-8Z" />
            <path d="M172,63.087a4,4,0,0,0-4,4,12.013,12.013,0,0,1-12,12,4,4,0,0,0,0,8,12.013,12.013,0,0,1,12,12,4,4,0,0,0,8,0,12.013,12.013,0,0,1,12-12,4,4,0,0,0,0-8,12.013,12.013,0,0,1-12-12A4,4,0,0,0,172,63.087Z" />
            <path d="M56,108a4,4,0,0,0-4-4A12.013,12.013,0,0,1,40,92a4,4,0,0,0-8,0,12.013,12.013,0,0,1-12,12,4,4,0,0,0,0,8,12.013,12.013,0,0,1,12,12,4,4,0,0,0,8,0,12.013,12.013,0,0,1,12-12A4,4,0,0,0,56,108Z" />
            <path d="M48.13,184a8,8,0,0,0,8,8h80a8,8,0,0,0,8-8V144h-96Z" />
          </g>
        </g>
      </svg>
    ),
    subMenuList: [
      {
        name: "Carnet",
        route: "/carnets",
      },

      {
        name: "Carnet Prepa",
        route: "/carnetPrepa",
      },
    ],
  },
  {
    subMenu: false,
    name: "Paramétres",
    route: "/settings",
    icon: (
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 512 512"
        xmlSpace="preserve"
      >
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
          <rect x={0} y={0} width={24} height={24} />
          <path
            fill="#000000"
            d="m272.066 512h-32.133c-25.989 0-47.134-21.144-47.134-47.133v-10.871c-11.049-3.53-21.784-7.986-32.097-13.323l-7.704 7.704c-18.659 18.682-48.548 18.134-66.665-.007l-22.711-22.71c-18.149-18.129-18.671-48.008.006-66.665l7.698-7.698c-5.337-10.313-9.792-21.046-13.323-32.097h-10.87c-25.988 0-47.133-21.144-47.133-47.133v-32.134c0-25.989 21.145-47.133 47.134-47.133h10.87c3.531-11.05 7.986-21.784 13.323-32.097l-7.704-7.703c-18.666-18.646-18.151-48.528.006-66.665l22.713-22.712c18.159-18.184 48.041-18.638 66.664.006l7.697 7.697c10.313-5.336 21.048-9.792 32.097-13.323v-10.87c0-25.989 21.144-47.133 47.134-47.133h32.133c25.989 0 47.133 21.144 47.133 47.133v10.871c11.049 3.53 21.784 7.986 32.097 13.323l7.704-7.704c18.659-18.682 48.548-18.134 66.665.007l22.711 22.71c18.149 18.129 18.671 48.008-.006 66.665l-7.698 7.698c5.337 10.313 9.792 21.046 13.323 32.097h10.87c25.989 0 47.134 21.144 47.134 47.133v32.134c0 25.989-21.145 47.133-47.134 47.133h-10.87c-3.531 11.05-7.986 21.784-13.323 32.097l7.704 7.704c18.666 18.646 18.151 48.528-.006 66.665l-22.713 22.712c-18.159 18.184-48.041 18.638-66.664-.006l-7.697-7.697c-10.313 5.336-21.048 9.792-32.097 13.323v10.871c0 25.987-21.144 47.131-47.134 47.131zm-106.349-102.83c14.327 8.473 29.747 14.874 45.831 19.025 6.624 1.709 11.252 7.683 11.252 14.524v22.148c0 9.447 7.687 17.133 17.134 17.133h32.133c9.447 0 17.134-7.686 17.134-17.133v-22.148c0-6.841 4.628-12.815 11.252-14.524 16.084-4.151 31.504-10.552 45.831-19.025 5.895-3.486 13.4-2.538 18.243 2.305l15.688 15.689c6.764 6.772 17.626 6.615 24.224.007l22.727-22.726c6.582-6.574 6.802-17.438.006-24.225l-15.695-15.695c-4.842-4.842-5.79-12.348-2.305-18.242 8.473-14.326 14.873-29.746 19.024-45.831 1.71-6.624 7.684-11.251 14.524-11.251h22.147c9.447 0 17.134-7.686 17.134-17.133v-32.134c0-9.447-7.687-17.133-17.134-17.133h-22.147c-6.841 0-12.814-4.628-14.524-11.251-4.151-16.085-10.552-31.505-19.024-45.831-3.485-5.894-2.537-13.4 2.305-18.242l15.689-15.689c6.782-6.774 6.605-17.634.006-24.225l-22.725-22.725c-6.587-6.596-17.451-6.789-24.225-.006l-15.694 15.695c-4.842 4.843-12.35 5.791-18.243 2.305-14.327-8.473-29.747-14.874-45.831-19.025-6.624-1.709-11.252-7.683-11.252-14.524v-22.15c0-9.447-7.687-17.133-17.134-17.133h-32.133c-9.447 0-17.134 7.686-17.134 17.133v22.148c0 6.841-4.628 12.815-11.252 14.524-16.084 4.151-31.504 10.552-45.831 19.025-5.896 3.485-13.401 2.537-18.243-2.305l-15.688-15.689c-6.764-6.772-17.627-6.615-24.224-.007l-22.727 22.726c-6.582 6.574-6.802 17.437-.006 24.225l15.695 15.695c4.842 4.842 5.79 12.348 2.305 18.242-8.473 14.326-14.873 29.746-19.024 45.831-1.71 6.624-7.684 11.251-14.524 11.251h-22.148c-9.447.001-17.134 7.687-17.134 17.134v32.134c0 9.447 7.687 17.133 17.134 17.133h22.147c6.841 0 12.814 4.628 14.524 11.251 4.151 16.085 10.552 31.505 19.024 45.831 3.485 5.894 2.537 13.4-2.305 18.242l-15.689 15.689c-6.782 6.774-6.605 17.634-.006 24.225l22.725 22.725c6.587 6.596 17.451 6.789 24.225.006l15.694-15.695c3.568-3.567 10.991-6.594 18.244-2.304z"
          />
          <path
            fill="#000000"
            d="m256 367.4c-61.427 0-111.4-49.974-111.4-111.4s49.973-111.4 111.4-111.4 111.4 49.974 111.4 111.4-49.973 111.4-111.4 111.4zm0-192.8c-44.885 0-81.4 36.516-81.4 81.4s36.516 81.4 81.4 81.4 81.4-36.516 81.4-81.4-36.515-81.4-81.4-81.4z"
          />
        </g>
      </svg>
    ),
  },
  {
    subMenu: false,
    name: "Logout",
    icon: (
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 512 512"
        xmlSpace="preserve"
      >
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
          <rect x={0} y={0} width={24} height={300} />
          <path
            fill="#000000"
            d="M255.15,468.625H63.787c-11.737,0-21.262-9.526-21.262-21.262V64.638c0-11.737,9.526-21.262,21.262-21.262H255.15
			c11.758,0,21.262-9.504,21.262-21.262S266.908,0.85,255.15,0.85H63.787C28.619,0.85,0,29.47,0,64.638v382.724
			c0,35.168,28.619,63.787,63.787,63.787H255.15c11.758,0,21.262-9.504,21.262-21.262
			C276.412,478.129,266.908,468.625,255.15,468.625z"
          />
          <path
            fill="#000000"
            d="M505.664,240.861L376.388,113.286c-8.335-8.25-21.815-8.143-30.065,0.213s-8.165,21.815,0.213,30.065l92.385,91.173
			H191.362c-11.758,0-21.262,9.504-21.262,21.262c0,11.758,9.504,21.263,21.262,21.263h247.559l-92.385,91.173
			c-8.377,8.25-8.441,21.709-0.213,30.065c4.167,4.21,9.653,6.336,15.139,6.336c5.401,0,10.801-2.041,14.926-6.124l129.276-127.575
			c4.04-3.997,6.336-9.441,6.336-15.139C512,250.302,509.725,244.88,505.664,240.861z"
          />
        </g>
      </svg>
    ),
    route: "/logout",
  },

  // {
  //   subMenu: false,
  //   name: "Parametres",
  //   icon: (
  //     <svg
  //       xmlns="http://www.w3.org/2000/svg"
  //       xmlnsXlink="http://www.w3.org/1999/xlink"
  //       width="24px"
  //       height="24px"
  //       viewBox="0 0 24 24"
  //       version="1.1"
  //     >
  //       <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
  //         <rect x={0} y={0} width={24} height={24} />
  //         <path
  //           d="M7,3 L17,3 C19.209139,3 21,4.790861 21,7 C21,9.209139 19.209139,11 17,11 L7,11 C4.790861,11 3,9.209139 3,7 C3,4.790861 4.790861,3 7,3 Z M7,9 C8.1045695,9 9,8.1045695 9,7 C9,5.8954305 8.1045695,5 7,5 C5.8954305,5 5,5.8954305 5,7 C5,8.1045695 5.8954305,9 7,9 Z"
  //           fill="#000000"
  //         />
  //         <path
  //           d="M7,13 L17,13 C19.209139,13 21,14.790861 21,17 C21,19.209139 19.209139,21 17,21 L7,21 C4.790861,21 3,19.209139 3,17 C3,14.790861 4.790861,13 7,13 Z M17,19 C18.1045695,19 19,18.1045695 19,17 C19,15.8954305 18.1045695,15 17,15 C15.8954305,15 15,15.8954305 15,17 C15,18.1045695 15.8954305,19 17,19 Z"
  //           fill="#000000"
  //           opacity="0.3"
  //         />
  //       </g>
  //     </svg>
  //   ),
  //   route: "/settings",
  // },
];
export default navigationConfig;
/*<path style="fill:#010002;" d="M85.889,49.632c0.704-1.241,1.056-2.685,1.056-4.32c0-2.596-0.955-4.565-2.864-5.913
			c-1.098-0.788-2.942-1.533-5.531-2.238v16.355C82.094,53.356,84.535,52.061,85.889,49.632z"/>
		<path style="fill:#010002;" d="M75.591,16.14c-2.739,0.107-4.69,0.931-5.848,2.488c-1.164,1.557-1.742,3.18-1.742,4.881
			c0,2.053,0.686,3.658,2.053,4.821c1.372,1.158,3.222,1.969,5.537,2.423V16.14z"/>
		<path style="fill:#010002;" d="M77.041,71.495c19.744,0,35.742-16.003,35.742-35.748S96.785,0,77.041,0
			S41.293,16.003,41.293,35.748C41.293,55.492,57.296,71.495,77.041,71.495z M65.626,32.155c-2.148-1.987-3.222-4.75-3.222-8.27
			c0-3.151,1.152-5.991,3.467-8.521c2.315-2.524,5.549-3.813,9.72-3.855V7.375h2.954v4.075c4.123,0.292,7.292,1.504,9.499,3.646
			c2.208,2.142,3.359,4.97,3.473,8.485h-5.448c-0.137-1.575-0.567-2.936-1.271-4.075c-1.307-2.094-3.389-3.192-6.247-3.3v15.15
			c4.809,1.349,8.073,2.613,9.798,3.789c2.798,1.951,4.195,4.833,4.195,8.646c0,5.519-1.796,9.434-5.376,11.755
			c-1.987,1.283-4.857,2.13-8.61,2.554v6.033h-2.954v-6.033c-6.033-0.394-10.126-2.53-12.286-6.408
			c-1.181-2.094-1.772-4.923-1.772-8.485h5.501c0.167,2.84,0.615,4.911,1.343,6.217c1.295,2.345,3.699,3.658,7.208,3.95V36.428
			C71.092,35.563,67.768,34.148,65.626,32.155z"/>
		<path style="fill:#010002;" d="M182.248,145.663c3.741-3.902,4.087-11.152,3.473-20.836c-4.41-0.292-10.901,0.436-13.193,0
			c-5.579-11.086-13.587-19.75-25.001-25.001c0.388-7.238,1.366-13.909,5.555-17.358c-10.185-0.698-18.802,6.188-24.297,12.501
			c-20.568-21.373-81.692-25.174-111.109,5.555c-5.072-0.382-4.493-10.681,2.082-9.028c-10.722-7.303-16.63,12.715-6.247,15.275
			c-8.652,12.345-9.469,38.874,2.082,48.606c1.689,14.625,4.272,28.349,11.385,37.55h23.342c-0.615-4.738-1.229-9.804-0.698-15.323
			c14.177,3.21,31.01,4.153,47.914,2.775c2.602,4.338,5.132,8.73,8.234,12.554h23.104c-0.841-6.11-1.76-12.524-0.095-18.802
			C134.299,173.063,162.922,165.801,182.248,145.663z M150.367,114.665c3.162,0,5.74,2.572,5.74,5.74s-2.578,5.746-5.74,5.746
			c-3.168,0-5.746-2.578-5.746-5.746S147.199,114.665,150.367,114.665z M102.603,92.403c-15.89-5.478-33.349-5.424-49.161,0.167
			l-1.802-3.717c16.958-5.997,35.682-6.062,52.729-0.179L102.603,92.403z"/>*/
